import angular from 'angular';
import _ from 'lodash';
import gridHeight from '../../core/shared-service/grid-utils';

class PrincipalUserCtrl {
    /*@ngInject*/
    constructor(
        $scope,
        $state,
        $sessionStorage,
        logger,
        $translate,
        KISS_USER,
        UsersFilter,
        PrincipalSvc,
        KissUserSvc,
        UserBo,
        LegalEntityGroupList
    ) {
        this.$scope = $scope;
        this.$state = $state;
        this.$sessionStorage = $sessionStorage;
        this.$translate = $translate;
        this.logger = logger;
        this.UsersFilter = UsersFilter;
        this.PrincipalSvc = PrincipalSvc;
        this.KissUserSvc = KissUserSvc;
        this.KISS_USER = KISS_USER;
        this.UserBo = UserBo;
        this.LegalEntityGroupList = LegalEntityGroupList;
    }

    $onInit() {
        this.headerTemplate = require('../principal-header-info.html');
        var ctrl = this;
        this.profilList = this.getProfilesToDisplay();
        this.statusList = this.KISS_USER.status;
        this.initGroupList();
        this.searchData =
            this.keepSearchData && this.$sessionStorage.listKissUsersCriteria
                ? this.$sessionStorage.listKissUsersCriteria
                : new this.UsersFilter();
        // indique que le do besion d'un Admin FO
        this.mustBeAdminFo ;
        //initialiser le filtre de recherche pour l'export
        this.preparedSearchFilter = this.searchData.preparBeforeSearch();

        // Gestion de la grille
        var defaultCellTemplate =
            '<a class="grid-cell-link" ui-sref="app.principal.consult.edit-user({ userId:row.entity.user.login})"><div class="ui-grid-cell-contents ui-grid-cursor-pointer">{{COL_FIELD CUSTOM_FILTERS}}</div></a>';
        // Liste
        this.gridOptions = {
            columnDefs: [
                {
                    name: 'user.lastname',
                    displayName: 'kiss_user.list.lastname',
                    headerCellFilter: 'translate',
                    cellTemplate: defaultCellTemplate,
                    cellClass: 'pointer',
                },
                {
                    name: 'user.firstname',
                    displayName: 'kiss_user.list.firstname',
                    headerCellFilter: 'translate',
                    cellTemplate: defaultCellTemplate,
                    cellClass: 'pointer',
                },
                {
                    name: 'user.email',
                    displayName: 'kiss_user.list.email',
                    headerCellFilter: 'translate',
                    cellTemplate: defaultCellTemplate,
                    cellClass: 'pointer',
                },
                {
                    name: 'user.login',
                    displayName: 'kiss_user.list.login',
                    headerCellFilter: 'translate',
                    cellTemplate: defaultCellTemplate,
                    cellClass: 'pointer',
                },
                {
                    name: 'user.getStatusLabel()',
                    displayName: 'kiss_user.list.status',
                    headerCellFilter: 'translate',
                    cellTemplate: defaultCellTemplate,
                    cellClass: 'pointer',
                    width: 80,
                },
            ],
            exporterOlderExcelCompatibility: true,
            useExternalPagination: true,
            useExternalSorting: true,
            enableSorting: true,
            enableGridMenu: false,
            enableColumnMenus: false,
            onRegisterApi: gridApi => {
                ctrl.gridApi = gridApi;
                // Sorting & pagination
                gridApi.core.on.sortChanged(ctrl.$scope, (grid, sortColumns) => {
                    sortColumns = _.map(sortColumns, col => ctrl.convertSort(col));
                    if (sortColumns && sortColumns.length > 0) {
                        ctrl.searchData.setSort(sortColumns);
                    } else {
                        ctrl.searchData.resetSort();
                    }
                    ctrl.search();
                });
                gridApi.pagination.on.paginationChanged(ctrl.$scope, (page, size) => {
                    ctrl.searchData.setPageSize(size);
                    ctrl.searchData.setPage(page - 1);
                    ctrl.search();
                });
            },
        };
        //recuperer la liste des headers pour l'export
        this.headers = _.map(this.gridOptions.columnDefs, column => {
            return this.$translate.instant(column.displayName);
        });
        ctrl.search();
    }

    sortChanged(grid, sortColumns) {
        sortColumns = _.map(sortColumns, col => this.convertSort(col));
        if (sortColumns && sortColumns.length > 0) {
            this.searchData.setSort(sortColumns);
        } else {
            this.searchData.resetSort();
        }
        this.search();
    }

    convertSort(col) {
        var columnField = _.find(this.KISS_USER.columnFieldMap, { field: col.field });
        if (col && col.sort) {
            return {
                direction: angular.uppercase(col.sort.direction),
                property: columnField ? columnField.property : col.field,
                priority: col.sort.priority,
            };
        }
        return {};
    }

    /**
     * Fournit la liste des groupes possibles.
     */
    getGroupList() {
        return this.groups;
    }

    initGroupList() {
        var allGroups = new this.LegalEntityGroupList();
        allGroups.name = 'Tous';
        allGroups.id = null;
        this.groups.splice(0, 0, allGroups);
    }

    paginationChanged(page, size) {
        this.searchData.setPageSize(size);
        this.searchData.setPage(page - 1);
        this.search();
    }

    search() {
        this.$sessionStorage.listKissUsersCriteria = this.searchData;
        var searchResult = this.PrincipalSvc.searchUsers(this.principal.detail.id, this.searchData);
        this.kissUserPromise = searchResult;
        searchResult.then(
            pageUsers => {
                this.gridOptions.data = pageUsers.users;
                this.gridOptions.totalItems = pageUsers.totalItems;
                if (this.searchData.role==='ALL' || this.searchData.role==='ADMIN_FO'){
                    this.mustBeAdminFo = this.gridOptions.totalItems === 0;
                }
                //enregistrer le filtre de recherche formaté pour l'export
                this.preparedSearchFilter = this.searchData.preparBeforeSearch();
            },
            () => {
                this.logger.error('error.search');
            }
        );
    }

    clearForm() {
        // Reset data
        this.searchData = new this.UsersFilter();
        // Reset form
        this.form.$setPristine();
        // Recherche
        this.search();
    }

    createNewUser() {
        var userBo = new this.UserBo();
        userBo.principal = this.principal;
        userBo.user.language = this.principal.detail.langCode;
        this.KissUserSvc.setUserCreationData(userBo);
        this.$state.go('app.principal.consult.create-user', {
            mustBeAdminFo: this.mustBeAdminFo,
            principalId: this.principal.detail.id,
        });
    }

    getProfilesToDisplay() {
        var profiles = angular.copy(this.KISS_USER.principal_profil);
        if (!this.principal.detail.processO2c) {
            _.pull(profiles, 'CUSTOMER_ACCOUNTANT');
            _.pull(profiles, 'SALES_ADMIN');
        }
        if (!this.principal.detail.processP2p) {
            _.pull(profiles, 'SUPPLIER_ACCOUNTANT');
        }
        if (!this.principal.detail.threeWayMatching) {
            _.pull(profiles, 'USER_WKF');
        }
        if (!this.principal.detail.hasDocumentarySpace) {
            _.pull(profiles, 'ADMIN_GED', 'USER_GED');
        }
        return profiles;
    }

    /**
     * Fournit la hauteur optimale de la grid en fonction du nombre d'element par page.
     */
    getGridHeight() {
        return gridHeight(this.gridApi);
    }
}

angular.module('app.principal').component('principalUser', {
    templateUrl: require('./principal-user.html'),
    controller: PrincipalUserCtrl,
    bindings: {
        principal: '<',
        keepSearchData: '<',
        groups: '<',
    },
});
